/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Row_CustomerInputs */

const en_wb_operations_row_customer = /** @type {(inputs: Wb_Operations_Row_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer`)
};

const lv_wb_operations_row_customer = /** @type {(inputs: Wb_Operations_Row_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klients`)
};

/**
* | output |
* | --- |
* | "Customer" |
*
* @param {Wb_Operations_Row_CustomerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_row_customer = /** @type {((inputs?: Wb_Operations_Row_CustomerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Row_CustomerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_row_customer(inputs)
	return en_wb_operations_row_customer(inputs)
});